enum ProductManualRoutesAPI {
  PRODUCT_MANUAL_LIST_REMOTE = '/customer-portal-service/Manual/Remote',
  PRODUCT_MANUAL_DOWNLOAD = '/customer-portal-service/Manual/Download/:id',
}

enum ProductManualRoutesApplication {
  PRODUCT_MANUAL = '/application/product-manual',
}

export {
  ProductManualRoutesAPI,
  ProductManualRoutesApplication,
};
